import { useEffect, useMemo, useState } from "react";
import FAQSection from "../home/FAQSection";
import Footer from "../home/Footer";
import Header from "../home/Header";
import MiniCart from "../home/MiniCart";
import TestimonialsSection from "../home/TestimonialsSection";
import VideosSection from "../home/VideosSection";
import SEOHead from "../seo/SEOHead";
import {
  CheckCircleIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  CloseIcon,
  StarIcon
  // CartIcon,
  // MinusIcon,
  // PlusIcon
} from "../home/HomeIcons";

/*
function formatPrice(value) {
  return `Rs. ${value.toLocaleString("en-IN")}`;
}
*/

function ProductGalleryModal({ images, activeIndex, onClose, onPrev, onNext }) {
  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose();
      if (event.key === "ArrowLeft") onPrev();
      if (event.key === "ArrowRight") onNext();
    };

    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKeyDown);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [onClose, onNext, onPrev]);

  const image = images[activeIndex];

  return (
    <div className="product-gallery-modal" role="dialog" aria-modal="true" aria-label="Product image viewer">
      <button className="gallery-modal-backdrop" onClick={onClose} aria-label="Close image viewer" />
      <div className="gallery-modal-shell">
        <button className="gallery-modal-close" onClick={onClose} aria-label="Close image viewer">
          <CloseIcon className="ui-icon" />
        </button>
        <button className="gallery-modal-nav prev" onClick={onPrev} aria-label="Previous image">
          <ChevronLeftIcon className="ui-icon" />
        </button>
        <div className="gallery-modal-image-wrap">
          <img src={image.src} alt={image.alt} />
        </div>
        <button className="gallery-modal-nav next" onClick={onNext} aria-label="Next image">
          <ChevronRightIcon className="ui-icon" />
        </button>
      </div>
    </div>
  );
}

function ProductTopSection({ product, onToast }) {
  // const [selectedSizeId, setSelectedSizeId] = useState(product.sizes[0].id);
  // const [quantity, setQuantity] = useState(product.sizes[0].unitCount === 1 ? 2 : 1);
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);

  /*
  const selectedSize = useMemo(
    () => product.sizes.find((size) => size.id === selectedSizeId) || product.sizes[0],
    [product.sizes, selectedSizeId]
  );

  useEffect(() => {
    setQuantity(selectedSize.unitCount === 1 ? 2 : 1);
  }, [selectedSize]);

  const totalWeight = selectedSize.unitCount * quantity;
  const belowMinimum = totalWeight < 2;
  */

  const openModal = (index) => {
    setActiveImageIndex(index);
    setModalOpen(true);
  };

  const nextImage = () => setActiveImageIndex((index) => (index + 1) % product.gallery.length);
  const prevImage = () => setActiveImageIndex((index) => (index - 1 + product.gallery.length) % product.gallery.length);

  /*
  const changeQuantity = (delta) => {
    setQuantity((current) => Math.max(1, current + delta));
  };

  const handleAddToCart = () => {
    if (belowMinimum) {
      onToast(product.minimumOrderText);
      return;
    }

    onToast(`Added ${quantity} x ${selectedSize.label} ${product.name} to cart.`);
  };
  */

  return (
    <>
      <section className="product-page-hero section">
        <div className="section-inner">
          <div className="product-page-grid">
            <div className="product-page-gallery">
              <button className="product-main-image" onClick={() => openModal(activeImageIndex)} aria-label="Open product image viewer">
                <img src={product.gallery[activeImageIndex].src} alt={product.gallery[activeImageIndex].alt} />
              </button>
              <div className="product-thumb-row">
                {product.gallery.map((image, index) => (
                  <button
                    key={image.src}
                    className={`product-thumb-button${activeImageIndex === index ? " active" : ""}`}
                    onClick={() => openModal(index)}
                    aria-label={`Open ${image.thumbAlt}`}
                  >
                    <img src={image.src} alt={image.thumbAlt} />
                  </button>
                ))}
              </div>
            </div>

            <div className="product-page-summary">
              <span className="section-label">{product.badge}</span>
              <h1 className="product-page-title">{product.name}</h1>
              <div className="product-page-rating" aria-label={`${product.rating} out of 5 stars from ${product.reviewCount} reviews`}>
                <div className="product-page-stars">
                  {[0, 1, 2, 3, 4].map((star) => (
                    <StarIcon key={star} className="ui-icon review-star-icon" filled={star < product.rating} />
                  ))}
                </div>
                <span>{product.reviewCount} reviews</span>
              </div>

              {/* Commerce UI paused for launch. Keep this block available for price, size, quantity, and cart enablement later.
              <div className="product-page-price-block">
                <div className="product-page-price-caption">{product.taxLabel}</div>
                <div className="product-page-price-row">
                  <span className="product-page-special-price">{formatPrice(selectedSize.specialPrice)}</span>
                  <span className="product-page-original-price">{formatPrice(selectedSize.price)}</span>
                </div>
                <div className="product-page-saving">You save {formatPrice(selectedSize.price - selectedSize.specialPrice)} on this size.</div>
              </div>

              <div className="product-page-option-group">
                <div className="product-page-option-label">{product.sizeLabel}</div>
                <div className="product-page-size-grid">
                  {product.sizes.map((size) => (
                    <button
                      key={size.id}
                      className={`product-size-pill${selectedSizeId === size.id ? " active" : ""}`}
                      onClick={() => setSelectedSizeId(size.id)}
                      aria-pressed={selectedSizeId === size.id}
                    >
                      <span>{size.label}</span>
                      <small>{formatPrice(size.specialPrice)}</small>
                    </button>
                  ))}
                </div>
              </div>

              <div className="product-page-purchase-row">
                <div className="product-page-option-label">Qty.</div>
                <div className="product-qty-and-actions">
                  <div className="qty-box" aria-label="Quantity selector">
                    <button onClick={() => changeQuantity(-1)} aria-label="Decrease quantity">
                      <MinusIcon className="ui-icon" />
                    </button>
                    <span>{quantity}</span>
                    <button onClick={() => changeQuantity(1)} aria-label="Increase quantity">
                      <PlusIcon className="ui-icon" />
                    </button>
                  </div>
                  <button className="btn-primary product-buy-btn" onClick={handleAddToCart}>
                    <CartIcon className="ui-icon button-icon" />
                    Add to Cart
                  </button>
                  <button className="btn-outline-green product-enquiry-btn" onClick={() => onToast(`Enquiry started for ${product.name} - ${selectedSize.label}.`)}>
                    {product.enquiryLabel}
                  </button>
                </div>
                <div className={`product-minimum-note${belowMinimum ? " warning" : ""}`}>{product.minimumOrderText}</div>
              </div>
              */}

              <div className="product-live-cta-row" aria-label="Product actions">
                <a className="product-amazon-btn" href={product.amazonUrl} target="_blank" rel="noopener noreferrer">
                  <img className="amazon-button-icon" src="/images/amazon-button-icon.svg" alt="" aria-hidden="true" />
                  <span>Buy On Amazon</span>
                </a>
                <a className="btn-outline-green product-enquiry-btn product-inquire-btn" href="/contact" onClick={() => onToast(`Enquiry started for ${product.name}.`)}>
                  Inquire Now
                </a>
              </div>

              <div className="product-short-description">
                <div className="product-page-option-label">Quick Overview</div>
                <ul>
                  {product.shortDescription.map((point) => (
                    <li key={point}>
                      <CheckCircleIcon className="ui-icon feature-check-icon" />
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {modalOpen && (
        <ProductGalleryModal
          images={product.gallery}
          activeIndex={activeImageIndex}
          onClose={() => setModalOpen(false)}
          onPrev={prevImage}
          onNext={nextImage}
        />
      )}
    </>
  );
}

function ProductDetailSections({ product }) {
  return (
    <section className="section product-story-section">
      <div className="section-inner">
        <div className="section-head center">
          <span className="section-label">Detailed Description</span>
          <h2 className="section-title">{product.overview.title}</h2>
          <p className="section-desc">{product.overview.text}</p>
        </div>

        <div className="product-story-stack">
          {product.detailSections.map((section, index) => {
            if (section.type === "banner") {
              return (
                <article
                  key={`${section.type}-${index}`}
                  className="product-story-banner"
                  style={{ backgroundImage: `linear-gradient(rgba(19, 55, 24, 0.62), rgba(19, 55, 24, 0.62)), url(${section.backgroundImage})` }}
                >
                  <span className="section-label">{section.eyebrow}</span>
                  <h3>{section.title}</h3>
                  <p>{section.text}</p>
                </article>
              );
            }

            if (section.type === "composition") {
              return (
                <article key={`${section.type}-${index}`} className="product-composition-layout">
                  <div className="product-composition-visual">
                    <img src={section.image} alt={section.imageAlt} />
                  </div>
                  <div className="product-composition-copy">
                    <span className="section-label">{section.eyebrow}</span>
                    <h3>{section.title}</h3>
                    <div className="product-composition-table">
                      {section.rows.map(([label, value]) => (
                        <div key={label} className="product-composition-row">
                          <span>{label}</span>
                          <strong>{value}</strong>
                        </div>
                      ))}
                    </div>
                  </div>
                </article>
              );
            }

            return (
              <article key={`${section.type}-${index}`} className={`product-story-split${section.imageSide === "right" ? " reverse" : ""}`}>
                <div className="product-story-media">
                  <img src={section.image} alt={section.imageAlt} />
                </div>
                <div className="product-story-copy">
                  <span className="section-label">{section.eyebrow}</span>
                  <h3>{section.title}</h3>
                  {section.paragraphs.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                  <ul>
                    {section.bullets.map((bullet) => (
                      <li key={bullet}>
                        <CheckCircleIcon className="ui-icon feature-check-icon" />
                        <span>{bullet}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}

function ProductHowToSection({ howToUse }) {
  return (
    <section className="section product-howto-section" id="how-to-use">
      <div className="section-inner">
        <div className="section-head center">
          <span className="section-label">How to Use</span>
          <h2 className="section-title">{howToUse.title}</h2>
          <p className="section-desc">{howToUse.intro}</p>
        </div>
        <div className="product-howto-grid">
          {howToUse.steps.map((step, index) => (
            <article key={step.title} className="product-howto-step">
              <div className="product-howto-number">{String(index + 1).padStart(2, "0")}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

function ProductApplicationsSection({ applications }) {
  return (
    <section className="section">
      <div className="section-inner">
        <div className="section-head center">
          <span className="section-label">Applications</span>
          <h2 className="section-title">Where It Fits Best</h2>
          <p className="section-desc">A clean, practical view of how the product can be used across home growing, landscape projects, and agriculture.</p>
        </div>
        <div className="product-application-zigzag">
          {applications.map((application, index) => (
            <article key={application.key} className={`product-application-row${index % 2 === 1 ? " reverse" : ""}`}>
              <div className="product-application-media">
                <img src={application.image} alt={application.imageAlt} />
              </div>
              <div className="product-application-card">
                <h3>{application.title}</h3>
                <p>{application.description}</p>
                <ul>
                  {application.bullets.map((bullet) => (
                    <li key={bullet}>
                      <CheckCircleIcon className="ui-icon feature-check-icon" />
                      <span>{bullet}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default function ProductDetailTemplate({ product }) {
  const [scrolled, setScrolled] = useState(false);
  const [cartOpen, setCartOpen] = useState(false);
  const [toast, setToast] = useState("");
  const cartItems = [];

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (!toast) return undefined;
    const timer = window.setTimeout(() => setToast(""), 2600);
    return () => window.clearTimeout(timer);
  }, [toast]);

  const schema = useMemo(() => ({
    "@context": "https://schema.org",
    "@type": "Product",
    "name": product.name,
    "description": product.shortDescription.join(" "),
    "image": product.gallery[0]?.src,
    "brand": {
      "@type": "Brand",
      "name": "Paras Organics"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": product.rating,
      "reviewCount": product.reviewCount
    }
  }), [product]);

  return (
    <>
      <SEOHead
        title={product.name}
        description={`${product.name} by Paras Organics. ${product.shortDescription[0]}`}
        path={`/${product.slug}`}
        image={product.gallery[0]?.src}
        keywords={[
          product.name,
          product.slug,
          "Paras Organics",
          "organic fertilizer",
          "plant growth",
          "soil health",
          "home gardening",
          "organic farming"
        ]}
        schema={schema}
      />
      <Header scrolled={scrolled} cartItems={cartItems} onCartClick={() => setCartOpen((open) => !open)} />
      {cartOpen && <MiniCart cartItems={cartItems} onClose={() => setCartOpen(false)} />}
      <main className="product-detail-page">
        <ProductTopSection product={product} onToast={setToast} />
        <ProductDetailSections product={product} />
        <VideosSection />
        <ProductHowToSection howToUse={product.howToUse} />
        <ProductApplicationsSection applications={product.applications} />
        <TestimonialsSection />
        <FAQSection />
      </main>
      <Footer />
      {toast && <div className="toast">{toast}</div>}
    </>
  );
}
